/**
 * Wrapper for Exception Logging API (Raven)
 */
const addRavenProjectContext = () => {
  const Raven = window?.['Raven'];

  if (Raven) {
    Raven.setTagsContext({
      project: 'gdpr-consent-banner',
    } as any);
  }
};

export default addRavenProjectContext;
